import * as React from 'react';
import DetailsCard from 'nomst/Components/SharedJobCollab/detailsCard';

interface SkillsCardProps {
    skills?: Answer[];
    title: string;
}

class SkillsCard extends React.PureComponent<SkillsCardProps, {}> {
    static isValidData(skills: Answer[]): boolean {
        const filteredSkills = SkillsCard._filterSkills(skills);
        return !!filteredSkills && filteredSkills.length > 0;
    }

    render(): React.ReactNode {
        const { skills, title } = this.props;
        const filteredSkills = SkillsCard._filterSkills(skills);

        if (!filteredSkills || filteredSkills.length === 0) {
            return null;
        }

        return (
            <DetailsCard title={title}>
                {filteredSkills.map(item => item.answer).join(', ')}
            </DetailsCard>
        );
    }

    private static _filterSkills(skills?: Answer[]): Nullable<Answer[]> {
        if (!skills) {
            return null;
        }

        return skills.filter(i => !!i.answer);
    }
}

export { SkillsCard };
export default SkillsCard;